import { ToothView } from '../../Enums/ToothView.enum';

interface CircleDefinition {
	centerX: number;
	centerY: number;
}

type ApicalDefinition = {
	[K in ToothView]?: CircleDefinition[];
};
type ToothApicalDefinition = Record<number, ApicalDefinition>;

export const apicalDefinition: ToothApicalDefinition = {
	18: {
		[ToothView.BUCCAL]: [
			{ centerX: 37, centerY: 155 },
			{ centerX: 120, centerY: 145 },
		],
		[ToothView.PALATAL]: [{ centerX: 100, centerY: 385 }],
	},
	17: {
		[ToothView.BUCCAL]: [
			{ centerX: 38, centerY: 127 },
			{ centerX: 123, centerY: 113 },
		],
		[ToothView.PALATAL]: [{ centerX: 110, centerY: 407 }],
	},
	16: {
		[ToothView.BUCCAL]: [
			{ centerX: 40, centerY: 80 },
			{ centerX: 140, centerY: 67 },
		],
		[ToothView.PALATAL]: [{ centerX: 115, centerY: 440 }],
	},
	15: {
		[ToothView.BUCCAL]: [{ centerX: 65, centerY: 103 }],
		[ToothView.PALATAL]: [{ centerX: 63, centerY: 395 }],
	},
	14: {
		[ToothView.BUCCAL]: [{ centerX: 71, centerY: 92 }],
		[ToothView.PALATAL]: [{ centerX: 52, centerY: 400 }],
	},
	13: {
		[ToothView.BUCCAL]: [{ centerX: 63, centerY: 61 }],
		[ToothView.PALATAL]: [{ centerX: 60, centerY: 420 }],
	},
	12: {
		[ToothView.BUCCAL]: [{ centerX: 40, centerY: 155 }],
		[ToothView.PALATAL]: [{ centerX: 50, centerY: 347 }],
	},
	11: {
		[ToothView.BUCCAL]: [{ centerX: 70, centerY: 117 }],
		[ToothView.PALATAL]: [{ centerX: 68, centerY: 380 }],
	},
	21: {
		[ToothView.BUCCAL]: [{ centerX: 65, centerY: 117 }],
		[ToothView.PALATAL]: [{ centerX: 65, centerY: 380 }],
	},
	22: {
		[ToothView.BUCCAL]: [{ centerX: 85, centerY: 155 }],
		[ToothView.PALATAL]: [{ centerX: 73, centerY: 347 }],
	},
	23: {
		[ToothView.BUCCAL]: [{ centerX: 78, centerY: 61 }],
		[ToothView.PALATAL]: [{ centerX: 80, centerY: 420 }],
	},
	24: {
		[ToothView.BUCCAL]: [{ centerX: 100, centerY: 92 }],
		[ToothView.PALATAL]: [{ centerX: 117, centerY: 400 }],
	},
	25: {
		[ToothView.BUCCAL]: [{ centerX: 85, centerY: 103 }],
		[ToothView.PALATAL]: [{ centerX: 85, centerY: 395 }],
	},
	26: {
		[ToothView.BUCCAL]: [
			{ centerX: 91, centerY: 65 },
			{ centerX: 190, centerY: 79 },
		],
		[ToothView.PALATAL]: [{ centerX: 110, centerY: 440 }],
	},
	27: {
		[ToothView.BUCCAL]: [
			{ centerX: 93, centerY: 112 },
			{ centerX: 178, centerY: 125 },
		],
		[ToothView.PALATAL]: [{ centerX: 105, centerY: 407 }],
	},
	28: {
		[ToothView.BUCCAL]: [
			{ centerX: 77, centerY: 145 },
			{ centerX: 160, centerY: 155 },
		],
		[ToothView.PALATAL]: [{ centerX: 95, centerY: 385 }],
	},
	38: {
		[ToothView.BUCCAL]: [
			{ centerX: 70, centerY: 412 },
			{ centerX: 135, centerY: 415 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 77, centerY: 108 },
			{ centerX: 145, centerY: 108 },
		],
	},
	37: {
		[ToothView.BUCCAL]: [
			{ centerX: 123, centerY: 430 },
			{ centerX: 193, centerY: 425 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 120, centerY: 72 },
			{ centerX: 192, centerY: 75 },
		],
	},
	36: {
		[ToothView.BUCCAL]: [
			{ centerX: 85, centerY: 495 },
			{ centerX: 165, centerY: 495 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 82, centerY: 20 },
			{ centerX: 165, centerY: 14 },
		],
	},
	35: {
		[ToothView.BUCCAL]: [{ centerX: 85, centerY: 446 }],
		[ToothView.LINGUAL]: [{ centerX: 125, centerY: 66 }],
	},
	34: {
		[ToothView.BUCCAL]: [{ centerX: 100, centerY: 432 }],
		[ToothView.LINGUAL]: [{ centerX: 98, centerY: 50 }],
	},
	33: {
		[ToothView.BUCCAL]: [{ centerX: 75, centerY: 410 }],
		[ToothView.LINGUAL]: [{ centerX: 70, centerY: 80 }],
	},
	32: {
		[ToothView.BUCCAL]: [{ centerX: 65, centerY: 378 }],
		[ToothView.LINGUAL]: [{ centerX: 63, centerY: 140 }],
	},
	31: {
		[ToothView.BUCCAL]: [{ centerX: 80, centerY: 377 }],
		[ToothView.LINGUAL]: [{ centerX: 76, centerY: 143 }],
	},
	41: {
		[ToothView.BUCCAL]: [{ centerX: 54, centerY: 377 }],
		[ToothView.LINGUAL]: [{ centerX: 59, centerY: 143 }],
	},
	42: {
		[ToothView.BUCCAL]: [{ centerX: 54, centerY: 378 }],
		[ToothView.LINGUAL]: [{ centerX: 57, centerY: 140 }],
	},
	43: {
		[ToothView.BUCCAL]: [{ centerX: 64, centerY: 412 }],
		[ToothView.LINGUAL]: [{ centerX: 70, centerY: 80 }],
	},
	44: {
		[ToothView.BUCCAL]: [{ centerX: 72, centerY: 432 }],
		[ToothView.LINGUAL]: [{ centerX: 72, centerY: 50 }],
	},
	45: {
		[ToothView.BUCCAL]: [{ centerX: 63, centerY: 446 }],
		[ToothView.LINGUAL]: [{ centerX: 25, centerY: 66 }],
	},
	46: {
		[ToothView.BUCCAL]: [
			{ centerX: 140, centerY: 495 },
			{ centerX: 62, centerY: 495 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 143, centerY: 20 },
			{ centerX: 63, centerY: 14 },
		],
	},
	47: {
		[ToothView.BUCCAL]: [
			{ centerX: 87, centerY: 430 },
			{ centerX: 20, centerY: 425 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 95, centerY: 69 },
			{ centerX: 22, centerY: 75 },
		],
	},
	48: {
		[ToothView.BUCCAL]: [
			{ centerX: 125, centerY: 412 },
			{ centerX: 62, centerY: 416 },
		],
		[ToothView.LINGUAL]: [
			{ centerX: 118, centerY: 108 },
			{ centerX: 53, centerY: 107 },
		],
	},
};
